import React from 'react';
import { offerDto } from '@app/components/anonymize-pro-landing/models';

interface OfferCardProps {
    offer: offerDto;
}
function OfferCard({ offer }: OfferCardProps) {
    return (
        <div className="flex h-[220px] max-w-[394px] flex-col items-center px-16 text-center">
            {React.createElement(offer.icon)}
            <p className="anonymize-p1 mb-2 mt-6 text-black-800">{offer.title}</p>
            <p className="anonymize-p4 text-black-600">{offer.description}</p>
        </div>
    );
}

export default OfferCard;
